import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Button } from '@bingads-webui-react/primitive-with-signal';
import { Link } from '@bingads-webui-react/fabric-with-signal';

import { tileFooterConfigShape } from './shared-props';
import { getStyles } from './get-styles';

export const TileFooterUnstyled = (props) => {
  const {
    classes,
    config: {
      buttons = [],
      isRequired = false,
      PageNavigator = null,
      footerTips = null,
    },
    classPrefix = '',
  } = props;
  if (!isRequired) { return null; }
  const hasButtons = !_.isEmpty(buttons);
  return (
    <div className={classes.footerContainer}>
      <div className={classNames(classes.footerContentContainer, `${classPrefix}tile-buttons`, 'tile-buttons')}>
        {hasButtons ? buttons.map(btn => (
          btn.type === 'link' ?
          (
            <Link
              href={btn.href}
              key={buttons.indexOf(btn)}
              name={btn.name || btn.text}
              disabled={btn.disabled || false}
              title={btn.text}
            >
              {btn.text}
            </Link>
          ) :
          (
            <Button
              className={classes.footerButton}
              key={btn.text}
              btnStyle={btn.type}
              onClick={btn.callback}
              name={btn.name || btn.text}
              disabled={btn.disabled || false}
              title={btn.text}
            >
              {btn.text}
            </Button>
          )
        )) : null}
        {PageNavigator && <PageNavigator />}
      </div>
      { footerTips }
    </div>
  );
};

TileFooterUnstyled.propTypes = {
  classes: PropTypes.shape(_.mapObject(getStyles(), _.constant(PropTypes.string.isRequired)))
    .isRequired,
  config: tileFooterConfigShape,
  classPrefix: PropTypes.string,
};

TileFooterUnstyled.defaultProps = {
  config: {
    isRequired: false,
    buttons: [],
  },
  classPrefix: '',
};

export const TileFooter = withDefaultStyles(
  TileFooterUnstyled,
  getStyles
);
